<template>
    <div class="form-info">
        <div class="search-layout">
            <swb-query-sort-area ref="query_model" :config="queryConfig" :queryKey="queryKey" :queryOnLoad="false" :queryHandler="queryHandler" :eventHandler="queryEventHanlder"></swb-query-sort-area>
        </div>
        <div v-if="checkBox" class="table-layout">
            <el-table :data="merchantBizRelList" border style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column v-if="checkBox" :selectable="selectable" align="center" type="selection" width="55"></el-table-column>
                <el-table-column prop="peerMerchantName" label="商户名称" align="left"></el-table-column>
                <el-table-column prop="peerInnerCode" label="内部标识" align="left" width="150"></el-table-column>
                <el-table-column prop="bizDesc" label="业务描述" align="left"></el-table-column>
                <el-table-column prop="dateStart" label="开始日期" align="center" width="100"></el-table-column>
                <el-table-column prop="dateEnd" label="截止日期" align="center" width="100"></el-table-column>
                <el-table-column label="评级" align="left" width="80">
                    <template slot-scope="rows">
                        <span class="font-red" v-if="rows.row.starLevel == 0">待入围</span>
                        <span class="font-black" v-else-if="rows.row.starLevel == 1">一级</span>
                        <span class="font-black" v-else-if="rows.row.starLevel == 2">二级</span>
                        <span class="font-black" v-else-if="rows.row.starLevel == 3">三级</span>
                        <span class="font-black" v-else-if="rows.row.starLevel == 4">四级</span>
                        <span class="font-black" v-else-if="rows.row.starLevel == 5">五级</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="table-layout" v-else>
            <el-table :data="merchantBizRelList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                <el-table-column width="55">
                    <template slot-scope="rows">
                        <div class="copy-radio" :class="{'circle' : checlMerchantBizRelInfo!= null && checlMerchantBizRelInfo.id == rows.row.id}">
                            <div class="circle-dot"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="peerMerchantName" label="商户名称" align="left"></el-table-column>
                <el-table-column prop="peerInnerCode" label="内部标识" align="left" width="150"></el-table-column>
                <el-table-column prop="bizDesc" label="业务描述" align="left"></el-table-column>
                <el-table-column prop="dateStart" label="开始日期" align="center" width="100"></el-table-column>
                <el-table-column prop="dateEnd" label="截止日期" align="center" width="100"></el-table-column>
                <el-table-column label="评级" align="left" width="80">
                    <template slot-scope="rows">
                        <span class="font-red" v-if="rows.row.starLevel == 0">待入围</span>
                        <span class="font-black" v-else-if="rows.row.starLevel == 1">一级</span>
                        <span class="font-black" v-else-if="rows.row.starLevel == 2">二级</span>
                        <span class="font-black" v-else-if="rows.row.starLevel == 3">三级</span>
                        <span class="font-black" v-else-if="rows.row.starLevel == 4">四级</span>
                        <span class="font-black" v-else-if="rows.row.starLevel == 5">五级</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="block pagination-layout">
            <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<!--服务显示分类信息-->
<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import merchtComnApi from '../../api/merchtComn'

    let mockConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "valueType": "String",
                "label": "商户名称",
                "code": "peerMerchantName",
                "basic": true
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "内部标识",
                "code": "peerInnerCode",
                "basic": true
            }
        ],
        "sortFields": []
    };

    export default {
        name: 'swb-merchant-biz-rel-select-x',
        desc: '商户业务关系-选择',
        props: {
            checkBox: {
                type: Boolean,
                default: true
            },
            peerMerchantIds: {// 多选的时候传入
                type: Array,
                default: function () {
                    return [];
                }
            },
            filter: {
                type: Object,
                default: null
            },
        },
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                merchantBizRelList: [],
                selectMerchantBizRelList: [],
                checlMerchantBizRelInfo: null,
                //
                queryConfig: mockConfigData,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            this.getTypeFlagMerchantBizRelList();
        },
        methods: {
            queryEventHanlder: function (postData) {
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.handlePageChange(1);
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getTypeFlagMerchantBizRelList();
            },
            getTypeFlagMerchantBizRelList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems = Object.assign(filterItems, self.filter || {});
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                merchtComnApi.getMerchantBizRelListX(postData, function (result) {
                    theLoading.close();
                    if(result.type == "info") {
                        self.merchantBizRelList = result.data.rows;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            selectable: function (row, index) {
                let peerMerchantIds = this.peerMerchantIds;
                if(peerMerchantIds.indexOf(row.peerMerchantId) >= 0) {
                    return false;
                } else {
                    return true;
                }
            },
            handleSelectionChange: function (val) {
                this.selectMerchantBizRelList = val;
            },
            handleCurrentChange: function (val) {
                this.checlMerchantBizRelInfo = Utils.merge({}, val);
            },
            getMerchantBizRelInfo: function (merchantBizRel) {
                let merchantBizRelInfo = {};
                if(merchantBizRel != null) {
                    merchantBizRelInfo.merchantId = merchantBizRel.merchantId;
                    merchantBizRelInfo.merchantType = merchantBizRel.merchantType;
                    merchantBizRelInfo.merchantName = merchantBizRel.merchantName;
                    merchantBizRelInfo.peerRealMerchantId = merchantBizRel.peerRealMerchantId;
                    merchantBizRelInfo.peerMerchantId = merchantBizRel.peerMerchantId;
                    merchantBizRelInfo.peerMerchantType = merchantBizRel.peerMerchantType;
                    merchantBizRelInfo.peerMerchantName = merchantBizRel.peerMerchantName;
                    merchantBizRelInfo.peerInnerCode = merchantBizRel.peerInnerCode;
                    merchantBizRelInfo.dateStart = merchantBizRel.dateStart;
                    merchantBizRelInfo.dateEnd = merchantBizRel.dateEnd;
                    merchantBizRelInfo.starLevel = merchantBizRel.starLevel;
                }
                return merchantBizRelInfo;
            },
            getMerchantBizRelList: function () {
                let merchantBizRelList = [];
                let selectmerchantBizRelList = this.selectMerchantBizRelList;
                if(selectmerchantBizRelList != null && selectmerchantBizRelList.length > 0) {
                    for(var i = 0; i < selectmerchantBizRelList.length; i++) {
                        let merchantBizRel = selectmerchantBizRelList[i];
                        let merchantBizRelInfo = this.getMerchantBizRelInfo(merchantBizRel);
                        merchantBizRelList.push(merchantBizRelInfo);
                    }
                }
                return merchantBizRelList;
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let checkBox = self.checkBox;
                if(checkBox) {
                    let merchantBizRelList = self.selectMerchantBizRelList;
                    if(merchantBizRelList != null && merchantBizRelList.length > 0) {
                        result.type = "info";
                        result.data = self.getMerchantBizRelList(merchantBizRelList);
                    } else {
                        result.type = 'warn';
                        result.message = '至少选择一个商户！';
                    }
                } else {
                    let merchantBizRelInfo = self.checlMerchantBizRelInfo;
                    if(merchantBizRelInfo != null) {
                        result.type = "info";
                        result.data = self.getMerchantBizRelInfo(merchantBizRelInfo);
                    } else {
                        result.type = 'warn';
                        result.message = '请选择一个商户！';
                    }
                }
                return result;
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/merchant/MerchantBizRelSelectX.vue